/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DatetimePeriod,
    DatetimePeriodFromJSON,
    DatetimePeriodFromJSONTyped,
    DatetimePeriodToJSON,
    Place,
    PlaceFromJSON,
    PlaceFromJSONTyped,
    PlaceToJSON,
} from './';

/**
 * 
 * @export
 * @interface VehicleUnavailability
 */
export interface VehicleUnavailability {
    /**
     * 
     * @type {string}
     * @memberof VehicleUnavailability
     */
    reasonMessage: string;
    /**
     * 
     * @type {Place}
     * @memberof VehicleUnavailability
     */
    place?: Place;
    /**
     * 
     * @type {DatetimePeriod}
     * @memberof VehicleUnavailability
     */
    datetimePeriod: DatetimePeriod;
    /**
     * 
     * @type {string}
     * @memberof VehicleUnavailability
     */
    monitoredObjectId: string;
}

export function VehicleUnavailabilityFromJSON(json: any): VehicleUnavailability {
    return VehicleUnavailabilityFromJSONTyped(json, false);
}

export function VehicleUnavailabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleUnavailability {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reasonMessage': json['reasonMessage'],
        'place': !exists(json, 'place') ? undefined : PlaceFromJSON(json['place']),
        'datetimePeriod': DatetimePeriodFromJSON(json['datetimePeriod']),
        'monitoredObjectId': json['monitoredObjectId'],
    };
}

export function VehicleUnavailabilityToJSON(value?: VehicleUnavailability | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reasonMessage': value.reasonMessage,
        'place': PlaceToJSON(value.place),
        'datetimePeriod': DatetimePeriodToJSON(value.datetimePeriod),
        'monitoredObjectId': value.monitoredObjectId,
    };
}


